import React from "react";
import { useNavigate } from "react-router-dom";
import FullScreenLoader from "../FullScreenLoader/FullScreenLoader";
const IntegrationsWidget = ({ integrations }) => {
  const navigate = useNavigate();

  if (!integrations) {
    return (
      <div className="dashboard-widget">
        <h3>Integrações</h3>
        < FullScreenLoader message="Carregando Integrações..." />
      </div>
    );
  }

  const getStatusColor = (status) => {
    switch (status) {
      case "connected":
        return "#2ecc71";
      case "error":
        return "#e74c3c";
      case "not_configured":
      default:
        return "#95a5a6";
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case "connected":
        return "Connected";
      case "error":
        return "Error";
      case "not_configured":
      default:
        return "Not Configured";
    }
  };

  const PROVIDER_CONFIG = {
    whatsapp_evolution: { label: "WhatsApp", icon: "📱" },
    email_smtp: { label: "Email", icon: "📧" },
    instagram_basic: { label: "Instagram", icon: "📸" },
    // adiciona outros providers aqui
  };

  // pega todas as keys, menos total_configured
  const providerKeys = Object.keys(integrations).filter(
    (key) => key !== "total_configured"
  );

  return (
    <div className="dashboard-widget">
      <h3 style={{ marginBottom: "15px" }}>Integrações</h3>

      <div style={{ marginBottom: "15px" }}>
        <div
          style={{
            fontSize: "32px",
            fontWeight: "bold",
            color: "#3498db",
            textAlign: "center",
            marginBottom: "5px",
          }}
        >
          {integrations.total_configured || 0}
        </div>
        <div
          style={{
            textAlign: "center",
            color: "#7f8c8d",
            fontSize: "14px",
          }}
        >
          Integrações Ativas
        </div>
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          marginBottom: "15px",
        }}
      >
        {providerKeys.map((providerKey) => {
          const status = integrations[providerKey] || "not_configured";
          const config = PROVIDER_CONFIG[providerKey] || {
            label: providerKey,
            icon: "🔌",
          };

          return (
            <div
              key={providerKey}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "12px",
                background: "var(--bg-tertiary",
                borderRadius: "6px",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                <span style={{ fontSize: "20px" }}>{config.icon}</span>
                <span style={{ fontSize: "14px", fontWeight: "500" }}>
                  {config.label}
                </span>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                <div
                  style={{
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                    background: getStatusColor(status),
                  }}
                />
                <span style={{ fontSize: "12px", color: "#7f8c8d" }}>
                  {getStatusText(status)}
                </span>
              </div>
            </div>
          );
        })}
      </div>

      <button
        onClick={() => navigate("/integrations")}
        style={{
          width: "100%",
          padding: "8px",
          background: "transparent",
          border: "1px solid #9b59b6",
          borderRadius: "4px",
          color: "#9b59b6",
          cursor: "pointer",
          fontSize: "14px",
        }}
      >
        Gerenciar Integrações →
      </button>
    </div>
  );
};

export default IntegrationsWidget;
